export default __webpack_public_path__ + "static/media/gear.b5aec7e0.svg";